var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHeroDivider(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1455,
    height: 292,
    viewBox: "0 0 1455 292",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H1455V146H0V0Z",
    fill: "#111111"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 146H1455V292H0V146Z",
    fill: "#F0F0F0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M183 248H213V277H183V248Z",
    fill: "#111111"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17 257H47V286H17V257Z",
    fill: "#111111"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M422 132H452V161H422V132Z",
    fill: "#111111"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M153 139H183V168H153V139Z",
    fill: "#111111"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M332 137H362V166H332V137Z",
    fill: "#111111"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M317 200H347V229H317V200Z",
    fill: "#111111"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M1003 150H1033V179H1003V150Z",
    fill: "#111111"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M1087 127H1117V156H1087V127Z",
    fill: "#86C6FA"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M799 156H829V185H799V156Z",
    fill: "#111111"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M1024 190H1054V219H1024V190Z",
    fill: "#111111"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M487 185H517V214H487V185Z",
    fill: "#111111"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M916 117H946V146H916V117Z",
    fill: "#111111"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M645 146H675V175H645V146Z",
    fill: "#111111"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M732 125H762V154H732V125Z",
    fill: "#111111"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M401 229H431V258H401V229Z",
    fill: "#111111"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M249 124H279V153H249V124Z",
    fill: "#111111"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M380 215H410V244H380V215Z",
    fill: "#111111"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M264 161H294V190H264V161Z",
    fill: "#111111"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M516 150H546V179H516V150Z",
    fill: "#111111"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M206 185H236V214H206V185Z",
    fill: "#111111"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M133 150H163V179H133V150Z",
    fill: "#111111"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M108 263H138V292H108V263Z",
    fill: "#111111"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M86 208H116V237H86V208Z",
    fill: "#111111"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M30 179H60V208H30V179Z",
    fill: "#111111"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M0 137H30V166H0V137Z",
    fill: "#111111"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M138 105H168V134H138V105Z",
    fill: "#FFACAC"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M375 117H405V146H375V117Z",
    fill: "#EDDCA6"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M546 97H576V126H546V97Z",
    fill: "#AEDFAF"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M618 82H648V111H618V82Z",
    fill: "#FFACAC"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M836 53H866V82H836V53Z",
    fill: "#EDDCA6"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M958 116H988V145H958V116Z",
    fill: "#EDDCA6"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M958 89H988V118H958V89Z",
    fill: "#FFACAC"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M781 124H811V153H781V124Z",
    fill: "#86C6FA"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M814 67H844V96H814V67Z",
    fill: "#86C6FA"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M592 52H622V81H592V52Z",
    fill: "#86C6FA"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M694 117H724V146H694V117Z",
    fill: "#EDDCA6"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M747 13H777V42H747V13Z",
    fill: "#AEDFAF"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M874 113H904V142H874V113Z",
    fill: "#AEDFAF"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M364 95H394V124H364V95Z",
    fill: "#86C6FA"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M38 32H68V61H38V32Z",
    fill: "#EDDCA6"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M607 130H637V159H607V130Z",
    fill: "#F0F0F0"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M469 110H499V139H469V110Z",
    fill: "#FFACAC"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M302 125H332V154H302V125Z",
    fill: "#AEDFAF"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M201 111H231V140H201V111Z",
    fill: "#EDDCA6"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M101 89H131V118H101V89Z",
    fill: "#86C6FA"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M60 118H90V147H60V118Z",
    fill: "#AEDFAF"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M17 89H47V118H17V89Z",
    fill: "#FFACAC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeroDivider);
export default __webpack_public_path__ + "static/media/hero_divider.b091f4d3382aa9945ed0b4c95d40b49a.svg";
export { ForwardRef as ReactComponent };